<template>
  <div>
    <v-card :disabled="isProcessing" :loading="isProcessing">
      <template v-slot:progress>
        <v-progress-linear
          absolute
          color="success"
          height="4"
          indeterminate
        ></v-progress-linear>
      </template>
      <v-tabs v-model="tab" class="crm-color" left dark icons-and-text>
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1">
          <v-toolbar-title>{{ title }}</v-toolbar-title>
        </v-tab>
        <v-spacer></v-spacer>
        <div class="buttons-tab"></div>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <v-card flat>
            <v-card-text>
              <div class="preview-list">
                <div class="preview-row">
                  <span class="preview-label">{{ $t("GENERAL.LABELS.ID") }}:</span>
                  <span class="preview-value">{{ requestData.id || "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("GENERAL.LABELS.NAME") }}:</span>
                  <span class="preview-value">{{ requestData.name || "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">Name (Latin):</span>
                  <span class="preview-value">{{ requestData.name_english || "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("GENERAL.LABELS.EMAIL") }}:</span>
                  <span class="preview-value">{{ requestData.email || "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("GENERAL.LABELS.PHONE") }}:</span>
                  <span class="preview-value">{{ requestData.phone || "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("GENERAL.LABELS.COMPANY") }}:</span>
                  <span class="preview-value">
                    <router-link
                      v-if="requestData.company_id && hasPermissions('companies-view-all')"
                      :to="{ name: 'companies-view', params: { id: requestData.company_id } }"
                      class="primary--text"
                    >
                      {{ requestData.company_name || "-" }}
                    </router-link>
                    <span v-else>{{ requestData.company_name || "-" }}</span>
                  </span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("COMPANIES.NOTES") }}:</span>
                  <span class="preview-value">{{ requestData.notes || "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("COMPANY_CONTACTS.ROLE") }}:</span>
                  <span class="preview-value">
                    <template v-if="requestData.roles?.length">
                      <v-chip
                        v-for="role in requestData.roles"
                        :key="role.id || role.value"
                        x-small
                        class="mr-1 mb-1"
                      >
                        {{ role.value }}
                      </v-chip>
                    </template>
                    <span v-else>-</span>
                  </span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("GENERAL.LABELS.STATUS") }}:</span>
                  <span class="preview-value">
                    <v-chip
                      x-small
                      :color="requestData.active ? 'success' : 'error'"
                      dark
                    >
                      {{ requestData.active ? $t("GENERAL.LABELS.ACTIVE") : $t("GENERAL.LABELS.INACTIVE") }}
                    </v-chip>
                  </span>
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="warning" @click="back">{{ $t("GENERAL.LABELS.BACK_BUTTON") }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import { GET_COMPANY_CONTACT } from "@/store/companyContact.module";
import { SHOW_SNACK } from "@/store/snack.module";

export default {
  name: "ViewCompanyContact",
  data() {
    return {
      title: this.$t("COMPANY_CONTACTS.VIEW"),
      tab: "tab-1",
      isProcessing: false,
      requestData: {},
    };
  },
  mounted() {
    this.selectCompanyContact();
  },
  methods: {
    back() {
      this.$router.push({ name: "company-contacts" });
    },
    selectCompanyContact() {
      this.isProcessing = true;
      this.$store
        .dispatch(GET_COMPANY_CONTACT, this.$route.params.id)
        .then((response) => {
          this.requestData = response;
        })
        .catch(() => {
          this.$store.dispatch(SHOW_SNACK, {
            message: this.$t("GENERAL.UNEXPECTED_ERROR"),
            type: "error",
          });
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
